import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { NutritionFolateDiagramContent } from "./NutritionFolateDiagram";
import { NutritionFolateKeyContent } from "./NutritionFolateKey";

const SvgNutritionFolateDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 860, 1110)}
      viewBox={diagramOnly ? "0 176 1024 860" : "0 0 1024 1110"}
    >
      <g id="nutrition-folate-diagram+key" clipPath="url(#clip0_18284_196610)">
        <rect width={1024} height={diagramOnly ? 860 : 1110} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionFolateKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <NutritionFolateDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18284_196610">
          <rect width={1024} height={1110} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196610">
          <rect width={1024} height={860} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionFolateDiagramKey;
